<template>
    <!-- Modal Principal -->
    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" role="dialog" aria-modal="true" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                <!-- ========== HEADER ========== -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-user-add-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">
                                {{ typeaction === 'add' ? 'Création' : 'Modification' }} {{ entityLabel }}
                            </p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer">
                        <i class="ri-close-line"></i>
                    </button>
                </div>

                <!-- ========== TABS NAVIGATION ========== -->
                <nav class="tf-tabs-nav flex overflow-x-auto">
                    <button v-for="(tab, index) in tabs" :key="index" type="button"
                            @click="activeTab = tab.id"
                            :class="['fa2-tab', activeTab === tab.id ? 'fa2-tab--active' : '']">
                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path :d="tab.icon" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        </svg>
                        <span>{{ tab.label }}</span>
                    </button>
                </nav>

                <!-- ========== FORM CONTENT ========== -->
                <div class="cf-dialog-body">
                    <!-- Messages -->
                    <div v-if="messagesucces" class="mb-4 alert alert-success !border-success/10 flex items-center" role="alert">
                        <div>{{ messagesucces }}</div>
                    </div>

                    <div v-if="messageerror" class="mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">
                        <div>{{ messageerror }}</div>
                    </div>

                    <!-- Tab 1: Informations de base -->
                    <div v-if="activeTab === 'basic'" class="space-y-6">
                        <!-- Type de collaborateur (si applicable) -->
                        <fieldset v-if="typedoc === 'col' && Items.jsondata.typecollaborateur !== 'Serveur'"
                                  class="cf-fieldset">
                            <legend class="cf-legend"><i class="ri-team-line"></i> Type de collaborateur</legend>
                            <div class="flex flex-wrap gap-2">
                                <button v-for="type in collaborateurTypes" :key="type.value" type="button"
                                        @click="Items.jsondata.typecollaborateur = type.value"
                                        :class="['cf-chip', Items.jsondata.typecollaborateur === type.value ? 'cf-chip--on' : '']">
                                    {{ type.label }}
                                </button>
                            </div>
                        </fieldset>

                        <!-- Informations principales -->
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                            <!-- IFU -->
                            <div class="space-y-2">
                                <label class="fa2-label">
                                    N° IFU
                                    <span class="tf-opt">(Optionnel)</span>
                                </label>
                                <div class="relative">
                                    <i class="ri-barcode-line fa2-field-icon"></i>
                                    <input v-model="Items.jsondata.general.ifu" type="text"
                                           class="fa2-inp pl-9"
                                           placeholder="Ex: 1234567890123">
                                </div>
                            </div>

                            <!-- Raison sociale -->
                            <div class="space-y-2">
                                <label class="fa2-label">
                                    <span class="fa2-req">*</span> Raison sociale
                                </label>
                                <div class="relative">
                                    <i class="ri-building-4-line fa2-field-icon"></i>
                                    <input v-model="Items.raisonsociale" type="text" required
                                           :class="['fa2-inp pl-9', errors.raisonsociale ? 'fa2-inp--error' : '']"
                                           placeholder="Nom de l'entreprise ou de la personne">
                                </div>
                                <p v-if="errors.raisonsociale" class="fa2-err">
                                    {{ errors.raisonsociale }}
                                </p>
                            </div>

                            <!-- Représentant -->
                            <div class="space-y-2 lg:col-span-2">
                                <label class="fa2-label">
                                    <span class="fa2-req">*</span> Représentant / Nom et prénom(s)
                                </label>
                                <div class="relative">
                                    <i class="ri-user-line fa2-field-icon"></i>
                                    <input v-model="Items.representant" type="text" required
                                           :class="['fa2-inp pl-9', errors.representant ? 'fa2-inp--error' : '']"
                                           placeholder="Nom et prénom du contact principal">
                                </div>
                                <p v-if="errors.representant" class="fa2-err">
                                    {{ errors.representant }}
                                </p>
                            </div>

                            <!-- Adresse -->
                            <div class="space-y-2">
                                <label class="fa2-label">
                                    <span class="fa2-req">*</span> Adresse
                                </label>
                                <div class="relative">
                                    <i class="ri-map-pin-line fa2-field-icon"></i>
                                    <input v-model="Items.jsondata.general.adresse" type="text" required
                                           :class="['fa2-inp pl-9', errors.adresse ? 'fa2-inp--error' : '']"
                                           placeholder="Adresse complète">
                                </div>
                                <p v-if="errors.adresse" class="fa2-err">
                                    {{ errors.adresse }}
                                </p>
                            </div>

                            <!-- Téléphone -->
                            <div class="space-y-2">
                                <label class="fa2-label">
                                    <span class="fa2-req">*</span> Téléphone
                                </label>
                                <div class="relative">
                                    <i class="ri-phone-line fa2-field-icon"></i>
                                    <input v-model="Items.jsondata.general.telephone" type="tel" required
                                           :class="['fa2-inp pl-9', errors.telephone ? 'fa2-inp--error' : '']"
                                           placeholder="Ex: +229 97 xx xx xx">
                                </div>
                                <p v-if="errors.telephone" class="fa2-err">
                                    {{ errors.telephone }}
                                </p>
                            </div>

                            <!-- Type de prix (pour clients) -->
                            <div v-if="typedoc === 'clt'" class="space-y-2 lg:col-span-2">
                                <label class="fa2-label">
                                    Type de prix / Catégorie de prix client
                                </label>
                                <div class="relative">
                                    <select v-model="Items.jsondata.paramdindication.param1"
                                            class="fa2-select fa2-select--slate">
                                        <option :value="null">Sélectionner un type de prix</option>
                                        <option v-for="(label, key) in priceTypes" :key="key" :value="key">
                                            {{ label }}
                                        </option>
                                    </select>
                                    <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                        <i class="ri-arrow-down-s-line fa2-select-caret"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Tab 2: Informations supplémentaires -->
                    <div v-if="activeTab === 'additional'" class="space-y-6">
                        <!-- Paramètre d'indication -->
                        <fieldset class="cf-fieldset">
                            <legend class="cf-legend"><i class="ri-flag-line"></i> Paramètre d'indication</legend>
                            <div class="relative">
                                <select v-model="Items.jsondata.paramdindication.param"
                                        class="fa2-select fa2-select--slate">
                                    <option :value="null">Sélectionner un paramètre</option>
                                    <option v-for="(param, index) in otherData.paramcom || []" :key="index"
                                            :value="param">
                                        {{ param.name }}
                                    </option>
                                </select>
                                <div class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                    <i class="ri-arrow-down-s-line fa2-select-caret"></i>
                                </div>
                            </div>
                        </fieldset>

                        <!-- Informations libres -->
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                            <div v-for="(field, index) in libreFields" :key="index" class="space-y-2">
                                <label class="fa2-label">
                                    {{ field.label }}
                                </label>
                                <div class="relative">
                                    <i class="ri-information-line fa2-field-icon"></i>
                                    <input v-model="Items.jsondata.adresses[field.key]" type="text"
                                           class="fa2-inp pl-9"
                                           :placeholder="field.placeholder">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Tab 3: Contacts -->
                    <div v-if="activeTab === 'contacts'" class="space-y-6">
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                            <div v-for="(field, index) in contactFields" :key="index" class="space-y-2">
                                <label class="fa2-label">
                                    {{ field.label }}
                                </label>
                                <div class="relative">
                                    <i class="ri-contacts-line fa2-field-icon"></i>
                                    <input v-model="Items.jsondata.contacts[field.key]" type="text"
                                           class="fa2-inp pl-9"
                                           :placeholder="field.placeholder">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Tab 4: Compte comptable -->
                    <div v-if="activeTab === 'accounting'" class="space-y-6">
                        <fieldset class="cf-fieldset">
                            <legend class="cf-legend"><i class="ri-calculator-line"></i> Compte de vente local</legend>

                            <div class="flex items-center gap-4">
                                <div class="flex-1">
                                    <div class="tf-compte">
                                        <div v-if="Items.jsondata.comptetva" class="flex items-center justify-between">
                                            <div>
                                                <p class="tf-compte-num">
                                                    {{ Items.jsondata.comptetva.numero }}
                                                </p>
                                                <p class="tf-compte-lib">
                                                    {{ Items.jsondata.comptetva.libelle }}
                                                </p>
                                            </div>
                                            <button @click="Items.jsondata.comptetva = null" type="button"
                                                    class="ds-btn-ghost !py-1 !px-2" aria-label="Retirer le compte">
                                                <i class="ri-close-line"></i>
                                            </button>
                                        </div>
                                        <div v-else class="tf-compte-empty">
                                            Aucun compte sélectionné
                                        </div>
                                    </div>
                                </div>
                                <button @click="btnmodalcompta('ventelocal')" type="button"
                                        class="ti-btn ti-btn-primary-full">
                                    <i class="ri-add-line"></i>
                                    Sélectionner
                                </button>
                            </div>

                            <p class="tf-hint">
                                Sélectionnez un compte comptable pour la vente locale
                            </p>
                        </fieldset>
                    </div>
                </div>

                <!-- ========== FOOTER ========== -->
                <div class="cf-dialog-foot">
                    <div class="tf-foot-note">
                        <span class="fa2-req">*</span> Champs obligatoires
                    </div>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">
                        Annuler
                    </button>

                    <button v-if="typeaction === 'add'" @click="saveItems" type="button"
                            class="ti-btn ti-btn-primary-full">
                        <i class="ri-check-line"></i>
                        Créer {{ entityLabel }}
                    </button>

                    <button v-if="typeaction === 'update'" @click="updateItems" type="button"
                            class="ti-btn ti-btn-primary-full">
                        <i class="ri-refresh-line"></i>
                        Mettre à jour
                    </button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>

    <!-- Composants enfants -->
    <modalcompta @elementSelectionnecompta="handleElementSelectionnecompta" ref="modalcompta" />
</template>

<script>
    import { randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import modalcompta from "@/components/views/pages/stock/articles/modal_compta";
    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "ClientFournisseurForm",

        components: {
            modalcompta
        },

        data() {
            return {
                // État du modal
                isdisplay: false,
                activeTab: 'basic',

                // Données du formulaire
                titlemodal: "",
                typedoc: "",
                viewserveur: "",
                typeaction: "add",

                // Entité
                Items: {
                    pid: '',
                    codecltfrs: '',
                    codeclient: '',
                    raisonsociale: '',
                    representant: '',
                    typ: '',
                    jsondata: {
                        comptetva: null,
                        typecollaborateur: 'none',
                        general: { adresse: '', telephone: '', ifu: '' },
                        adresses: { info: '', info1: '', info2: '', info3: '' },
                        contacts: { info: '', info1: '', info2: '', info3: '' },
                        autreinfo: {},
                        paramdindication: { param: null, param1: null },
                    },
                    jsonother: {}
                },

                // Données externes
                datainputlibelleforms: {},
                libelleachat: {},
                otherData: {},

                // Messages et erreurs
                messagesucces: "",
                messageerror: "",
                errors: {},

                // Configuration des tabs
                tabs: [
                    { id: 'basic', label: 'Informations de base', icon: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
                    { id: 'additional', label: 'Informations libres', icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
                    { id: 'contacts', label: 'Contacts', icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
                    { id: 'accounting', label: 'Compte comptable', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2' },
                ],

                // Types de collaborateurs
                collaborateurTypes: [
                    { value: 'none', label: 'Non spécifié' },
                    { value: 'Représentants', label: 'Représentant' },
                    { value: 'Commercial', label: 'Commercial' },
                    { value: 'Acheteurs', label: 'Acheteur' },
                    { value: 'Chauffeur', label: 'Chauffeur' },
                    { value: 'Autre', label: 'Autre' }
                ],
            };
        },

        computed: {
            entityLabel() {
                const labels = {
                    'frs': 'fournisseur',
                    'clt': 'client',
                    'col': 'collaborateur'
                };
                let label = labels[this.typedoc] || 'enregistrement';
                if (this.typedoc === 'col' && this.viewserveur === 'Serveur') {
                    label = 'serveur';
                }
                return label;
            },

            priceTypes() {
                return {
                    prixvente: this.datainputlibelleforms.prixvente || 'Prix de vente',
                    prixvente1: this.datainputlibelleforms.prixvente1 || 'Prix de vente 1',
                    prixvente2: this.datainputlibelleforms.prixvente2 || 'Prix de vente 2',
                    prixvente3: this.datainputlibelleforms.prixvente3 || 'Prix de vente 3',
                    prixvente4: this.datainputlibelleforms.prixvente4 || 'Prix de vente 4',
                    prixvente5: this.datainputlibelleforms.prixvente5 || 'Prix de vente 5',
                    prixvente6: this.datainputlibelleforms.prixvente6 || 'Prix de vente 6',
                    prixvente7: this.datainputlibelleforms.prixvente7 || 'Prix de vente 7',
                };
            },

            libreFields() {
                return [
                    { key: 'info', label: this.libelleachat?.adresseexpedition?.informationlibre || 'Information libre 1', placeholder: 'Information complémentaire 1' },
                    { key: 'info1', label: this.libelleachat?.adresseexpedition?.informationlibre1 || 'Information libre 2', placeholder: 'Information complémentaire 2' },
                    { key: 'info2', label: this.libelleachat?.adresseexpedition?.informationlibre2 || 'Information libre 3', placeholder: 'Information complémentaire 3' },
                    { key: 'info3', label: this.libelleachat?.adresseexpedition?.informationlibre3 || 'Information libre 4', placeholder: 'Information complémentaire 4' },
                ];
            },

            contactFields() {
                return [
                    { key: 'info', label: this.libelleachat?.informationlibre?.informationlibre || 'Contact 1', placeholder: 'Information de contact 1' },
                    { key: 'info1', label: this.libelleachat?.informationlibre?.informationlibre1 || 'Contact 2', placeholder: 'Information de contact 2' },
                    { key: 'info2', label: this.libelleachat?.informationlibre?.informationlibre2 || 'Contact 3', placeholder: 'Information de contact 3' },
                    { key: 'info3', label: this.libelleachat?.informationlibre?.informationlibre3 || 'Contact 4', placeholder: 'Information de contact 4' },
                ];
            },
        },

        methods: {
            // Gestion du modal
            show(titlemodal, typeaction, typedoc, Items, alldata, datainputlibelleforms, libelleachat, viewserveur = "none") {
                this.titlemodal = titlemodal;
                this.typeaction = typeaction;
                this.typedoc = typedoc;
                this.viewserveur = viewserveur;
                this.Items = JSON.parse(JSON.stringify(Items));
                this.otherData = alldata || {};
                this.datainputlibelleforms = datainputlibelleforms || {};
                this.libelleachat = libelleachat || {};

                // Ajuster le type de collaborateur pour les serveurs
                if (this.viewserveur === "Serveur") {
                    this.Items.jsondata.typecollaborateur = this.viewserveur;
                }

                this.resetErrors();
                this.isdisplay = true;
                document.body.style.overflow = 'hidden';
            },

            close() {
                this.isdisplay = false;
                document.body.style.overflow = '';
                this.resetErrors();
                this.$emit('closed');
            },

            // Validation
            validateForm() {
                this.resetErrors();
                let isValid = true;

                const requiredFields = [
                    { field: 'raisonsociale', value: this.Items.raisonsociale, message: 'La raison sociale est requise' },
                    { field: 'representant', value: this.Items.representant, message: 'Le représentant est requis' },
                    { field: 'adresse', value: this.Items.jsondata.general.adresse, message: 'L\'adresse est requise' },
                    { field: 'telephone', value: this.Items.jsondata.general.telephone, message: 'Le téléphone est requis' },
                ];

                requiredFields.forEach(({ field, value, message }) => {
                    if (!value || value.trim() === '') {
                        this.errors[field] = message;
                        isValid = false;
                    }
                });

                // Validation spécifique pour le téléphone
                if (this.Items.jsondata.general.telephone && !this.isValidPhone(this.Items.jsondata.general.telephone)) {
                    this.errors.telephone = 'Format de téléphone invalide';
                    isValid = false;
                }

                return isValid;
            },

            isValidPhone(phone) {
                // Validation basique du téléphone
                const phoneRegex = /^[\d\s\+\-\(\)]{8,20}$/;
                return phoneRegex.test(phone);
            },

            resetErrors() {
                this.errors = {};
                this.messagesucces = "";
                this.messageerror = "";
            },

            // Actions CRUD
            async saveItems() {
                if (!this.validateForm()) return;
                await this.submitForm('add');
            },

            async updateItems() {
                if (!this.validateForm()) return;
                await this.submitForm('update');
            },

            async submitForm(actionType) {
                this.$store.dispatch('lancerchargement', true);

                try {
                    const endpoint = actionType === 'add' ? 'add' : 'maj';
                    const url = `${process.env.VUE_APP_API_URL}/egldsds74gescom8571714dfe/cltfrs/${endpoint}/${this.typedoc}/${this.$store.state.appsociete}/${randomString()}`;

                    const response = await axios.post(url, this.Items, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true
                    });

                    this.handleResponse(response.data, actionType);
                } catch (error) {
                    this.handleError(error);
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }
            },

            handleResponse(data, actionType) {
                if (data.success) {
                    this.messagesucces = data.message;
                    this.messageerror = "";

                    // Notification de succès
                    this.$toast?.success(data.message);

                    if (actionType === 'add') {
                        // Réinitialiser le formulaire après création réussie
                        this.resetForm();
                    } else {
                        // Fermer le modal après modification réussie
                        setTimeout(() => {
                            this.close();
                            this.$emit('closed');
                        }, 1500);
                    }
                } else {
                    this.handleErrorResponse(data);
                }
            },

            handleErrorResponse(data) {
                this.messagesucces = "";

                if (data.datamessage && data.datamessage.length > 0) {
                    this.messageerror = data.datamessage.join(', ');
                } else {
                    this.messageerror = data.message || 'Une erreur est survenue';
                }

                this.$toast?.error(this.messageerror);
            },

            handleError(error) {
                console.error('Erreur lors de l\'envoi:', error);
                this.messageerror = "Une erreur est survenue. Veuillez contacter votre administrateur.";
                this.$toast?.error(this.messageerror);
            },

            resetForm() {
                this.Items = {
                    pid: '',
                    codecltfrs: '',
                    codeclient: '',
                    raisonsociale: '',
                    representant: '',
                    typ: this.typedoc,
                    jsondata: {
                        comptetva: null,
                        typecollaborateur: this.viewserveur === 'Serveur' ? 'Serveur' : 'none',
                        general: { adresse: '', telephone: '', ifu: '' },
                        adresses: { info: '', info1: '', info2: '', info3: '' },
                        contacts: { info: '', info1: '', info2: '', info3: '' },
                        autreinfo: {},
                        paramdindication: { param: null, param1: null },
                    },
                    jsonother: {}
                };

                // Revenir à l'onglet de base
                this.activeTab = 'basic';
            },

            // Comptabilité
            btnmodalcompta(typ) {
                const listedatable = this.otherData.compteventelocal || [];
                const titlemodal = "Plan comptable";

                this.$refs.modalcompta.show(titlemodal, listedatable, typ);
            },

            handleElementSelectionnecompta(elementSelectionne) {
                if (elementSelectionne.typ === "ventelocal") {
                    this.Items.jsondata.comptetva = elementSelectionne.value;
                }
            },
        },

        beforeUnmount() {
            document.body.style.overflow = '';
        },
    };
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

/* Onglets fa2-tab (mécanique activeTab inchangée) */
.tf-tabs-nav { border-bottom:1px solid var(--cf-border); flex-shrink:0; padding:0 0.5rem; }
.fa2-tab { position:relative; display:flex; align-items:center; gap:6px;
  padding:10px 16px; font-size:0.82rem; font-weight:600; border:none;
  border-bottom:2px solid transparent; background:none; cursor:pointer;
  transition:all .15s; white-space:nowrap; color:var(--cf-muted); }
.fa2-tab:hover { color:var(--cf-ink); background:rgb(var(--primary)/0.06); }
.fa2-tab--active { color:rgb(var(--primary))!important;
  border-bottom-color:rgb(var(--primary)); background:rgb(var(--primary)/0.08); }

/* Champs charte (cf. fa2-*) */
.fa2-inp { width:100%; height:40px; padding:0 12px; border-radius:0.25rem;
  border:1px solid rgb(var(--input-border,203 213 225)); background:#fff;
  color:var(--cf-ink); font-size:0.82rem; outline:none;
  transition:border-color .2s, box-shadow .2s; }
.fa2-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary)/0.10); }
.fa2-inp--error { border-color:rgb(var(--danger)); background:#fef2f2; }
.fa2-select { width:100%; height:40px; padding-right:28px; border-radius:0.25rem;
  border-width:1px; border-style:solid; background:#fff; color:var(--cf-ink);
  font-size:0.82rem; appearance:none; outline:none; cursor:pointer; transition:all .2s; }
.fa2-select--slate { border-color:rgb(var(--input-border,203 213 225)); }
.fa2-select--slate:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary)/0.10); }
.fa2-select-caret { color:var(--cf-faint); font-size:1.1rem; }
.fa2-label { font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em;
  font-weight:600; color:var(--cf-muted); display:flex; align-items:center; gap:4px; }
.fa2-req { color:rgb(var(--danger)); }
.fa2-field-icon { position:absolute; top:50%; transform:translateY(-50%); left:0;
  padding-left:12px; display:flex; align-items:center; pointer-events:none;
  color:var(--cf-faint); font-size:1rem; z-index:1; }
.fa2-err { font-size:0.72rem; color:rgb(var(--danger)); margin-top:2px; }

/* Éléments locaux */
.tf-opt { color:var(--cf-faint); font-size:0.68rem; text-transform:none; letter-spacing:0; }
.tf-hint { font-size:0.72rem; color:var(--cf-muted); margin-top:0.6rem; }
.tf-foot-note { margin-right:auto; font-size:0.78rem; color:var(--cf-muted); }
.tf-compte { padding:0.7rem 0.9rem; background:var(--cf-surface);
  border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); }
.tf-compte-num { font-weight:600; color:var(--cf-ink-strong); margin:0; }
.tf-compte-lib { color:var(--cf-muted); font-size:0.82rem; margin:0; }
.tf-compte-empty { color:var(--cf-faint); font-size:0.82rem; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--xl { max-width:100%; } }
</style>
